import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

import StyledSelect from '../../components/StyledSelect';
import FieldError from '../../components/FieldError';
import Tooltip from '../../components/Tooltip';


// The selected option is derived from the field value, so it also follows
// form.reset() and initial values (previously passed as `defaultValue`).
const renderSelectField = (props) => {
  const {
    input: { value, onChange, onBlur },
    label,
    options,
    meta: { touched, error },
    placeholder = 'Выберите...',
    noOptionsMessage = 'Не найдено',
    tooltipText = '',
  } = props;
  const selectedOption = options.find(option => option.value === value) || null;
  return (
    <FormGroup noMargin className="form-group">
      <Label>{label}</Label>
      {tooltipText && <Tooltip text={tooltipText} />}
      <StyledSelect
        onChange={data => onChange(data.value)}
        onBlur={() => onBlur(value)}
        options={options}
        value={selectedOption}
        isSearchable={false}
        blurInputOnSelect={false}
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage}
      />
      {touched && error && <FieldError error={error} />}
    </FormGroup>
  );
};

renderSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  tooltipText: PropTypes.string,
};


export default renderSelectField;
